export default __webpack_public_path__ + "static/media/twojug.4f29345f.jfif";